
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent.ts";
import { MenuComponent } from "@/assets/ts/components/MenuComponent.ts";
import { isDocPage, version } from "@/core/helpers/documentation.ts";
import { asideMenuIcons } from "@/core/helpers/config.ts";
import DocMenuConfig from "@/core/config/DocMenuConfig";
import MainMenuConfig from "@/core/config/MainMenuConfig";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const hasActiveChildren = match => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      isDocPage,
      DocMenuConfig,
      MainMenuConfig,
      asideMenuIcons,
      version
    };
  }
});
